import { type FC } from 'react'

import {
  OfferDiscountTypeEnumV2,
  type SellerPromotionV2,
} from '@redteclab/api/clients/bully'

import { ProductSellerVoucherLabelDiscount } from './components/ProductSellerVoucherLabelDiscount'

type ProductSellerVoucherLabelProps = {
  sellerPromotion: SellerPromotionV2
}

export const ProductSellerVoucherLabel: FC<ProductSellerVoucherLabelProps> = ({
  sellerPromotion,
}) => {
  if (
    sellerPromotion.discountType === OfferDiscountTypeEnumV2.TotalPercent ||
    sellerPromotion.discountType === OfferDiscountTypeEnumV2.TotalAmount
  ) {
    return (
      <ProductSellerVoucherLabelDiscount sellerPromotion={sellerPromotion} />
    )
  }

  return null
}
